import { CoreIntegrationTypes } from './core-integration.types';

export enum AVIGILON_REGIONS {
  US = 'us',
  EU = 'eu'
}

export type FullAvigilonIntegration = {
  id: string;
  username: string;
  password: string;
  webhook_url: string;
  org_id: number;
  region: AVIGILON_REGIONS;
  type: CoreIntegrationTypes.avigilon;
  validated: boolean;
  settings: {
    notification_minutes_before_start: number;
    unlock_page_instructions: string;
    send_credentials_by_email?: boolean;
    send_credentials_by_sms?: boolean;
  };
};

export type AvigilonExternalIdResponse = {
  entries: ExternalIdEntry[];
};

export type ExternalIdEntry = {
  id: number;
  name: string;
};
